import { BREADCRUMB_MENU_NAVIGATION, JPCARD_INITIALIZE, LOGOUT } from "./actions";

export const initialState = {
  jp: null,
  breadcrumbMenuListing: [],
  application: null
};

const AppNavigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case JPCARD_INITIALIZE: {
      const { jp, application } = action.payload;
      return {
        ...state,
        jp,
        application
      };
    }
    case BREADCRUMB_MENU_NAVIGATION: {
      const { breadcrumbMenuListing } = action.payload;
      return {
        ...state,
        breadcrumbMenuListing
      };
    }
    case LOGOUT: {
      return { ...initialState }; // reset all AppNavigation state on logout
    }
    default: {
      return { ...state };
    }
  }
};

export default AppNavigationReducer;
